module.exports = __webpack_public_path__ + "img/badge-list-thumb-058.e4dfb249.png";